import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import CreatePublicProcurementActOrders from "./Create";
import ListPublicProcurementActOrders from "./List";
import EditPublicProcurementActOrders from "./Edit";
import ShowPublicProcurementActOrders from "./Show";
//params
export const PUBLIC_PROCUREMENT_ACT_ORDERS = "procurement-act/orders";
//permissions

export const resources = {
  isMenu: true,
  icon: <AirportShuttleIcon />,
  name: PUBLIC_PROCUREMENT_ACT_ORDERS,
  title: "Поръчки",
  list: <ListPublicProcurementActOrders />,
  create: <CreatePublicProcurementActOrders />,
  edit: <EditPublicProcurementActOrders />,
  show: <ShowPublicProcurementActOrders />,
  permission: "publicProcurementAct",
};

//api url
